export interface IFile {
  name: string;
  size: number;
  type: string;
  file?: File;
}

export interface MultiUpload {
  files: IFile[];
  totalSize: number;
}

/**
 * Defines the structure for a file type definition.
 */
export interface FileType {
  displayName: string;
  mimeType: MIMEType;
  iconName: string;
}

/**
 * Explicitly handled MIME types
 */
export enum MIMEType {
  PDF = 'application/pdf',
  JPG = 'image/jpeg',
  PNG = 'image/png'
}

/**
 * Registry of explicitly handled file types.
 *
 * @remarks
 * This object is immutable. To add a new file type, add a new key-value pair
 * conforming to the {@link FileType} interface.
 */
export const FILE_TYPES = {
  PDF: {
    displayName: 'PDF',
    mimeType: MIMEType.PDF,
    iconName: 'file-pdf'
  },
  JPG: {
    displayName: 'JPG',
    mimeType: MIMEType.JPG,
    iconName: 'file-jpg'
  },
  PNG: {
    displayName: 'PNG',
    mimeType: MIMEType.PNG,
    iconName: 'file-png'
  }
} as const satisfies Record<string, FileType>;
